import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import { DigiServiceService } from '../services/digi-service.service';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material'

interface Alert {
  id: number;
  deviceId: string;
  alertType: string;
  type: string;
  description: string;
  priority: 'critical' | 'high' | 'medium' | 'low';
  status: 'active' | 'resolved' | 'acknowledged';
  timestamp: Date;
}

@Component({
  selector: 'app-digi-alert-popup',
  templateUrl: './digi-alert-popup.component.html',
  styleUrls: ['./digi-alert-popup.component.scss']
})
export class DigiAlertPopupComponent implements OnInit {
  @Output() closePopupEvent = new EventEmitter<void>();
@ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  alerts: Alert[] = [];
  filteredAlerts: Alert[] = [];
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  generatorIds: any;
  selectedDevice: any;
  timeFilter: any;
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  customeSelectedDate: any;
  selectedFilter: any;
  reportColumns:any;
  dataSource!: MatTableDataSource<any>;
  isData: boolean=false;
  constructor(private digiService:DigiServiceService,private matDialog:MatDialog) {}

  ngOnInit() {
  this.getDigiIds();
  this.timeFilter = 'Today';
  this.filters('Today');
  }
  getDigiIds(){
    this.digiService.getDigiIds({userid:this.currentUserData.userid}).subscribe(resp=>{
      if(resp.status){
        this.generatorIds = resp.result;
        this.selectedDevice = resp.result[0]
        console.log("gebnerators id",this.selectedDevice)
      }
    })
  }
  onDeviceSelect(device: any) {
    this.selectedDevice = device;
    this.filters(this.selectedFilter.duration);
  }
 filters(duration:any){
    
      if (duration == "Custom") {
        let dialogRef = this.matDialog.open(CustomDateComponent, {
          autoFocus: false,
          height: '350px', width: '450px', data: { "details": "", "action": "Add",selectedDate:this.customeSelectedDate}
      });


      dialogRef.afterClosed().subscribe(value => {
        console.log("Value======= ", value);
        if (value) {
          this.selectedFilter = {...value,duration: duration,deviceid:this.selectedDevice.deviceid}
          this.customeSelectedDate = value;
        }
        this.getReportData(this.selectedFilter)
      });
      } else{
        this.selectedFilter = {duration:duration,deviceid:this.selectedDevice.deviceid};
        this.getReportData(this.selectedFilter)
      }
  }
  getReportData(filter:any){
    this.digiService.getAlerts(filter).subscribe(res=>{
      if(res.status){
        this.isData = true;
        this.reportColumns = Object.keys(res.result[0]);
        this.dataSource = new MatTableDataSource(res.result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log("asdsa",res.result)
      }  else {
        this.isData = false;
        this.dataSource =new MatTableDataSource([]);
      }
    })
  }
   generateDummyData() {
    this.alerts = [
      {
        id: 1,
        deviceId: 'BH-1133BHAR3',
        alertType: 'Voltage Alert',
        type: 'voltage',
        description: 'L1 voltage has dropped below 200V. Current reading: 185.5V',
        priority: 'critical',
        status: 'active',
        timestamp: new Date(Date.now() - 5 * 60000) // 5 minutes ago
      },
      {
        id: 2,
        deviceId: 'DG-001',
        alertType: 'Fuel Level Low',
        type: 'fuel',
        description: 'Fuel level has reached critical threshold at 15%. Immediate refuel required.',
        priority: 'high',
        status: 'active',
        timestamp: new Date(Date.now() - 12 * 60000) // 12 minutes ago
      },
      {
        id: 3,
        deviceId: 'BH-1133BHAR3',
        alertType: 'Oil Temperature High',
        type: 'temperature',
        description: 'Oil temperature exceeded safe operating limit at 105°C',
        priority: 'high',
        status: 'acknowledged',
        timestamp: new Date(Date.now() - 25 * 60000) // 25 minutes ago
      },
      {
        id: 4,
        deviceId: 'DG-002',
        alertType: 'RPM Fluctuation',
        type: 'rpm',
        description: 'Engine RPM showing irregular fluctuations between 1800-2100 RPM',
        priority: 'medium',
        status: 'active',
        timestamp: new Date(Date.now() - 35 * 60000) // 35 minutes ago
      },
      {
        id: 5,
        deviceId: 'DG-001',
        alertType: 'System Maintenance',
        type: 'system',
        description: 'Scheduled maintenance reminder: Oil change due in 48 hours',
        priority: 'low',
        status: 'active',
        timestamp: new Date(Date.now() - 2 * 3600000) // 2 hours ago
      },
      {
        id: 6,
        deviceId: 'BH-1133BHAR3',
        alertType: 'Power Factor Low',
        type: 'voltage',
        description: 'Power factor dropped to 0.65, affecting energy efficiency',
        priority: 'medium',
        status: 'resolved',
        timestamp: new Date(Date.now() - 4 * 3600000) // 4 hours ago
      },
      {
        id: 7,
        deviceId: 'DG-002',
        alertType: 'Current Overload',
        type: 'voltage',
        description: 'L3 current exceeded rated capacity at 125A for 2+ minutes',
        priority: 'critical',
        status: 'resolved',
        timestamp: new Date(Date.now() - 6 * 3600000) // 6 hours ago
      },
      {
        id: 8,
        deviceId: 'DG-001',
        alertType: 'Communication Loss',
        type: 'system',
        description: 'Temporary communication loss detected for 3 minutes',
        priority: 'high',
        status: 'resolved',
        timestamp: new Date(Date.now() - 12 * 3600000) // 12 hours ago
      },
      {
        id: 9,
        deviceId: 'BH-1133BHAR3',
        alertType: 'Voltage Imbalance',
        type: 'voltage',
        description: 'Phase voltage imbalance detected: L1=230V, L2=225V, L3=240V',
        priority: 'medium',
        status: 'acknowledged',
        timestamp: new Date(Date.now() - 18 * 3600000) // 18 hours ago
      },
      {
        id: 10,
        deviceId: 'DG-002',
        alertType: 'Fuel Quality Alert',
        type: 'fuel',
        description: 'Fuel quality sensor indicates potential contamination',
        priority: 'high',
        status: 'active',
        timestamp: new Date(Date.now() - 24 * 3600000) // 24 hours ago
      },
      {
        id: 11,
        deviceId: 'BH-1133BHAR3',
        alertType: 'Load Imbalance',
        type: 'voltage',
        description: 'Significant load imbalance detected across phases',
        priority: 'medium',
        status: 'resolved',
        timestamp: new Date(Date.now() - 36 * 3600000) // 36 hours ago
      },
      {
        id: 12,
        deviceId: 'DG-001',
        alertType: 'Battery Voltage Low',
        type: 'voltage',
        description: 'Starting battery voltage dropped to 11.8V, charging required',
        priority: 'low',
        status: 'resolved',
        timestamp: new Date(Date.now() - 48 * 3600000) // 48 hours ago
      }
    ];
  }
  filterAlerts() {
    this.filteredAlerts = this.alerts.filter(alert => {
      const deviceMatch = this.selectedDevice === 'all' || alert.deviceId === this.selectedDevice;
      return deviceMatch;
    });
  }

  formatTimestamp(timestamp: Date): string {
    const now = new Date();
    const diffInMs = now.getTime() - timestamp.getTime();
    const diffInMinutes = Math.floor(diffInMs / 60000);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 1) {
      return 'Just now';
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours}h ago`;
    } else if (diffInDays < 7) {
      return `${diffInDays}d ago`;
    } else {
      return timestamp.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }

  getActiveAlertsCount(): number {
    return this.filteredAlerts.filter(alert => alert.status === 'active').length;
  }

  // ✅ Export to Excel
  exportToExcel() {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.filteredAlerts.map(a => ({
        'Device ID': a.deviceId,
        'Alert Type': a.alertType,
        'Description': a.description,
        'Priority': a.priority,
        'Status': a.status,
        'Timestamp': a.timestamp.toLocaleString()
      }))
    );

    const workbook: XLSX.WorkBook = { Sheets: { 'Alerts': worksheet }, SheetNames: ['Alerts'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    saveAs(data, `alerts_export_${new Date().toISOString().split('T')[0]}.xlsx`);
  }

  // ✅ Export to PDF
  exportToPDF() {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.text('Alerts Report', 14, 15);

  // Use autoTable from jsPDF instance
  (doc as any).autoTable({
    startY: 25,
    head: [['Device ID', 'Alert Type', 'Description', 'Priority', 'Status', 'Timestamp']],
    body: this.filteredAlerts.map(a => [
      a.deviceId,
      a.alertType,
      a.description,
      a.priority,
      a.status,
      a.timestamp.toLocaleString()
    ]),
    styles: { fontSize: 9, cellPadding: 3 },
    headStyles: { fillColor: [41, 128, 185], textColor: 255 },
  });

  doc.save(`alerts_export_${new Date().toISOString().split('T')[0]}.pdf`);
}

  // Unified export function
  exportAlerts(format: 'pdf' | 'excel') {
    if (format === 'pdf') {
      this.exportToPDF();
    } else {
      this.exportToExcel();
    }
  }

  closePopup(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.closePopupEvent.emit();

    const popupElement = document.querySelector('.alert-popup-overlay') as HTMLElement;
    if (popupElement) {
      popupElement.style.display = 'none';
    }
  }

  onOverlayClick(event: Event) {
    if (event.target === event.currentTarget) {
      this.closePopup(event);
    }
  }
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
